var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"articles"},[_c('div',{staticClass:"articles__container articles__container--large"},[_c('div',{staticClass:"articles__grid"},_vm._l((_vm.items),function(item){return _c('News',{attrs:{"content":item}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }